module.exports = __webpack_public_path__ + "img/icon-bag-note.08aab5a6.svg";